import React, { useState } from "react";
import { Button, Box, Typography, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { esignIcons } from "./icons";

const AttachFiles = () => {
  const [files, setFiles] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const truncateFileName = (name, length = 10) => {
    return name.length > length ? name.substring(0, length) + "..." : name;
  };

  const getFileIcon = (file) => {
    if (!file) return null;
    const fileType = file.type;

    if (fileType.includes("pdf")) {
      return "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
    } else if (fileType.includes("image")) {
      return URL.createObjectURL(file);
    } else {
      return "/images/docIcon.svg";
    }
  };

  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`file${index + 1}`, file);
    });

    try {
      const response = await fetch("YOUR_API_ENDPOINT", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      console.log("Upload successful", result);
    } catch (error) {
      console.error("Error uploading files", error);
    }
  };

    return (
        <Box>
            {/* Upload Button */}
            <Button
                component="label"
                variant="outlined"
                sx={{
                borderRadius: "10px",
                height: "36px",
                width: "119px",
                border: "1px solid #DDDDDD",
                display: "flex",
                alignItems: "center",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 400,
                color: "#1D1D1D",
                padding: "2px",
                justifyContent: "space-evenly",
                }}
            >
                {esignIcons.AttachIcon}
                Attach file
                <input type="file" hidden multiple onChange={handleFileChange} accept="image/*,.pdf,.txt" />
            </Button>

            {/* Selected Files List */}
            
            {files && (
            <Box>
                {files.map((file, index) => (
                    <Box
                    key={index}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        backgroundColor: "#F6F6F6",
                        padding: "10px",
                        borderRadius: "10px",
                        mt: 2,
                        mb: 2,
                        position: "relative",
                        height: "40px",
                        justifyContent: "space-between",
                    }}
                    >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <img src={getFileIcon(file)} alt="File Icon" width="20" height="20" />
                        <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#1D1D1D" }}>
                        {truncateFileName(file.name)} ({(file.size / 1024 / 1024).toFixed(2)} Mb)
                        </Typography>
                    </Box>
                    <IconButton onClick={() => { setPreviewFile(file); setPreviewOpen(true); }}>
                        {esignIcons.VisibilityIcon}
                    </IconButton>
                    <IconButton onClick={() => handleRemoveFile(index)} sx={{ position: "absolute", right: -12, top: -15 }}>
                        {esignIcons.RemoveCircleIcon}
                    </IconButton>
                    </Box>
                ))}
            </Box>)}


            {/* Preview Modal */}
            <Modal open={previewOpen} onClose={() => setPreviewOpen(false)}>
                <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    height: "80%",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    p: 2,
                    overflow: "auto",
                    borderRadius: "10px",
                }}
                >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h6">Preview: {previewFile?.name}</Typography>
                    <IconButton onClick={() => setPreviewOpen(false)}>
                    <CloseIcon />
                    </IconButton>
                </Box>
                {previewFile && (
                    <iframe
                    src={URL.createObjectURL(previewFile)}
                    title="File Preview"
                    width="100%"
                    height="90%"
                    style={{ border: "none" }}
                    />
                )}
                </Box>
            </Modal>
        </Box>
    );
};

export default AttachFiles;
